// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"6f783c8838b5e2085ebd","293":"939f6b14c793e4a8eb0c","518":"d865c5ed1ffebc7fcf34","779":"3b201c1b5b03cf9da578"}[chunkId] + ".js";
};